import { z } from 'zod'

import type { ComplianceSettingsFormSchema } from '../../../types/complianceSettingsFormSchema'

// The mention texts are validated in LegalMentionsModal before they reach this form.
export const getComplianceSettingsFormSchema = (): ComplianceSettingsFormSchema => {
  return z.object({
    legalFormSettings: z.object({
      isLegalGuaranteeOfConformity: z.boolean(),
      isMemberOfAccreditedAssociation: z.boolean(),
      isVatOnDebitsEnabled: z.boolean(),
    }),
    legalMentions: z.object({
      custom: z.object({
        earlyPaymentDiscount: z.string().nullable(),
        latePaymentPenaltyRate: z.string().nullable(),
      }),
    }),
  })
}
